// Navbar.jsx
import React from "react";
import Header from "../header/Header";

export default function Navbar(props) {
  return (
    <div className="fixed-navbar">
      <Header
        hclass="compact-header"     // ✅ add this
        Logo={props.Logo}
      />
    </div>
  );
}
